import { z } from "zod";

export const agentReceiptSchema = z
    .object({
        inputId: z.string().min(1),
        status: z.enum(["accepted", "duplicate"]),
        acceptedCursor: z.number().int().positive(),
        turnId: z.string().min(1).optional(),
    })
    .strict();

export type AgentReceipt = z.infer<typeof agentReceiptSchema>;
